export default function initCounters() : void {
    const $counters = document.querySelectorAll<HTMLElement>('[data-counter]');

    $counters.forEach($container => {
        new Counter($container);
    });
}

/**
 * Make a counter on each elements having a `data-counter`
 * 
 * <span
 *   data-counter
 *   data-counter-duration="2000" (Optional) => Set the animation duration in ms (default: 1000)
 * >42</span>
 */
class Counter {
    $container: HTMLElement;
    duration: number;
    updateInterval: number;
    totalFrames: number;
    currentNumber = 0;
    countTo: number;

    constructor($counter: HTMLElement) {
        const numberMatching = $counter.innerText.match(/\d+/);
        
        if (!numberMatching) {
            return;
        }

        this.countTo = parseInt(numberMatching[0]);

        // Wrap the number with a span
        $counter.innerHTML = $counter.innerText.replace(numberMatching[0], `<span>0</span>`);
        this.$container = $counter.querySelector('span');

        // The counter duration
        this.duration = parseInt($counter.dataset.counterDuration) || 1000;
        // How long each frames should last if we want to update the animation 60 times per second
        this.updateInterval = 100 / 60;
        // Number of frames to complete the animation
        this.totalFrames = Math.round(this.duration / this.updateInterval);

        // Start the counter only when he's visible in viewport
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio >= 1) {
                this.startCounter();
                observer.unobserve(this.$container);
            }
        }, { threshold: [1] });
        observer.observe(this.$container);
    }

    /**
     * Start the counter
     * 
     * @return {void}
     */
    startCounter() : void {
        let frame = 0;
        const counter = setInterval(() => {
            frame++;
            const progress = this.easeInQuad(frame / this.totalFrames);
            const currentCount = Math.round(this.countTo * progress);

            this.$container.innerText = currentCount.toString();

            if (frame === this.totalFrames) {
                clearInterval(counter);
            }
        }, this.updateInterval);
    }

    /**
     * Speeds the counter as it progresses
     * 
     * @param {number} number 
     * 
     * @return {number}
     */
    easeInQuad = (number: number) : number => number * number;
}
